<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialog" width="80%" append-to-body :before-close="handleClose">
    <div class="max-height-60">
      <el-form :model="form" :inline="true" label-width="100px">
        <el-form-item prop="vipName" label="门店名称:" v-if="title=='明细'">
          <div class="form-width-ms">{{form.storeName}}</div>
        </el-form-item>
        <el-form-item prop="rechPhone" label="手机号码:">
          <label slot="label">手&nbsp;&nbsp;机&nbsp;&nbsp;号</label>
          <div class="form-width-ms">
            <el-input size="mini" oninput="this.value=this.value.replace(/\D/g,'')" pattern="[0-9]*" v-model="form.mobilePhone" maxlength="11">
            </el-input>
          </div>
        </el-form-item>
        <el-form-item prop="vipName" label="会员名字:">
          <div class="form-width-ms">{{form.memberName}}</div>
        </el-form-item>
        <el-form-item prop="rechPhone" label="身份证号:">
          <div class="form-width-ms">
            <el-input style="padding-left:0px;" placeholder='请输入会员身份证号' pattern="[0-9]*" maxlength="18" v-model="form.manageIdentity"></el-input>
          </div>
        </el-form-item>
        <br />
        <el-form-item prop="rechNumber" label="疗程编码:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">
              <span>{{form.courseProjectNum}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="rechNumber" label="疗程账户:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">
              <span>{{form.courseProjectName}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="paid" label="购买来源:">
          <div class="form-width-ms">
            <span v-if="form.courseType=='0'">直接购买</span>
            <span v-else-if="form.courseType=='3'">加价转疗程</span>
            <span v-else>促销购买</span>
          </div>
        </el-form-item>
        <br>
        <el-form-item prop="paid" label="购买次数:">
          <div class="form-width-ms">{{form.courseCount}}</div>
        </el-form-item>
        <el-form-item prop="paid" label="成交金额:">
          <div class="form-width-ms">{{form.courseProjectMoney}}</div>
        </el-form-item>
        <el-form-item prop="paid" label="可退次数:">
          <div class="form-width-ms">{{form.courseConsumeCount}}</div>
        </el-form-item>
        <br>
        <el-form-item prop="paid" label="补偿金额:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">
              <span>{{form.courseCompensation}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="refundNumber" label="退款次数:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">
              <span>{{form.refundNumber}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="summation" label="退款金额:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">
              <span>{{form.courseRefundMoney}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="收款银行:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{refundType}}</div>
          </div>
        </el-form-item>
        <br>
        <el-form-item label="收款账户:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{refundAccount}}</div>

          </div>
        </el-form-item>
        <el-form-item label="收款人:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{payee}}</div>

          </div>
        </el-form-item>
        <br />
        <el-form-item prop="cause" label="退款备注:">
          <div class="form-width-ms">
            <div v-if="title=='明细'">{{refundReason}}</div>
          </div>
        </el-form-item>
        <!-- <el-form-item prop="cause" label="附带文件:" required>
          <div v-if="title=='明细'" v-for="(item,index) in  fileList" :key="index">
            <div class="flex">
              <el-image  @click="(url = item.url,openImageDialog=true,urlForm = item)" :src='item.url' style="width: 100px;height: 100px">
                <div slot="error" class="image-slot flex">
                  <div title="点击下载文件" style="cursor: pointer;width: 300px;" @click="directDown(item)">{{item.fileName}}</div>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item prop="cause" label="附带文件:" required>
          <div class="flex">
            <div style="width:80px;cursor: pointer; margin: 5px;overflow: hidden;text-overflow:ellipsis;white-space:nowrap" v-for="(item,index) in  fileList" :key="index">
              <el-image @click="(url = item.url,openImageDialog=true,urlForm = item)" :src='item.url'>
                <div slot="error" class="image-slot">
                  <div title="点击下载文件" style="cursor: pointer;width:300px;" @click="directDown(item)">{{item.fileName}}</div>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <div class="flex justify-start align-start flex-wrap padding-top">
          <staffsles ref="staffsles" @staffslesData="staffslesData"></staffsles>
          <admin ref="admin" @adminData="adminData"></admin>
          <manager ref="manager" @managerData="managerData"></manager>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" plain @click="cancel()">关闭</el-button>
    </span>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="图片预览" :visible.sync="openImageDialog" append-to-body>
      <el-image style="height: 60vh;width:100%" :src="url" fit="contain"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" plain @click="openImageDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmImage(openImageDialog=false)">下 载</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { selectOne, refCourseList, refOrderDownload } from "@/api/eashier.js";
import { partten } from "../../../../../partten/index.js";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
export default {
  components: {
    staffsles,
    manager,
    admin,
  },
  data() {
    return {
      detailDialog: false,
      activeNames: "员工",
      rowfromWidth: "80px",
      sessionStorageData: {}, //门店参数集合
      refundType: null,
      refundAccount: null,
      payee: null,
      refundReason: null,
      fileData: [],
      fileList: [],
      title: "", //弹窗标题
      form: {}, //主对象
      openImageDialog: false,
      url: "",
      urlForm: {},
    };
  },
  methods: {
    directDown(item) {
      let url = {
        fileName: item.fileName,
        filePath: item.filePath,
      };
      refOrderDownload(url).then((res) => {
        //console.log(res);
        let blob = new Blob([res]);
        var a = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = item.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    confirmImage() {
      let url = {
        fileName: this.urlForm.fileName,
        filePath: this.urlForm.filePath,
      };
      refOrderDownload(url).then((res) => {
        //console.log(res);
        let blob = new Blob([res]);
        var a = document.createElement("a");
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = this.urlForm.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = Object.assign({});
      this.fileList = [];
      this.detailDialog = false;
      this.fileData = [];
    },
    //自定义文件上传拦截方法
    uploadFile(file) {
      this.fileData.append("fileList", file.file);
    },
    setStaff() {
      var that = this;
      setTimeout(() => {
        that.$refs.staffsles.show(that.form.staffLists);
        that.$refs.admin.show(that.form.adminList);
        that.$refs.manager.show(that.form.managerList);
      }, 800);
    },
    //员工占比返回方法
    staffslesData(v) {
      this.form.staffLists = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.adminList = [...v];
    },
    cancel() {
      this.detailDialog = false;
      this.$emit("detailData");
    },
    //组件传值
    show(form, title) {
      this.title = title;
      this.detailDialog = true;
      this.sessionStorageData = JSON.parse(
        sessionStorage.getItem("sessionStorageData")
      );
      this.getData(form);
    },
    getData(form) {
      refCourseList({
        refundNum: form.refundNum,
        refundOrderId: form.id,
        storeId: form.storeId,
      }).then((res) => {
        //console.log(res);
        if (res.code == "000000") {
          if (res.rows.length == 0) {
            this.$alert("未找到相关明细", "提示", {
              confirmButtonText: "确定",
              confirmButtonClass: "confirmbtnFalses",
              type: "warning",
              center: true,
              callback: (action) => {},
            });
          } else {
            delete res.rows[0].refundMoney;
            delete res.rows[0].compensation;
            this.form = res.rows[0];
            this.form.refundMoney = form.refundMoney;
            this.form.compensation = form.compensation;
            this.refundType = form.refundType;
            this.refundAccount = form.refundAccount;
            this.payee = form.payee;
            this.refundReason = form.refundReason;
            let staffLists = [];
            res.rows[0].entities.forEach((item) => {
              let items = {
                ratio: item.saleRatio,
                staffNames: item.brandNumber + "--" + item.saleStaffName,
                id: item.saleStaffId,
                staffName: item.saleStaffName,
                brandNumber: item.brandNumber,
                identityCard: item.saleIdentityCard,
              };
              staffLists.push(items);
            });
            if (staffLists.length == 0) {
              staffLists.push({ ratio: 100 });
            }
            this.form.staffLists = staffLists;
            this.fileList = res.rows[0].fileLists;
            this.fileList.forEach((item) => {
              item.url = partten.https + item.filePath + "/" + item.fileName;
              console.log(item);
              console.log(item.url);
            });
            selectOne({ type: 5, orderNum: this.form.refundNum }).then(
              (res) => {
                if (res.code == "000000") {
                  let managerList = [];
                  let adminList = [];
                  res.rows.forEach((item) => {
                    if (item.staffType == 0) {
                      item.staffNames =
                        item.brandNumber + "--" + item.staffName;
                      managerList.push(item);
                    }
                    if (item.staffType == 1) {
                      item.staffNames =
                        item.brandNumber + "--" + item.staffName;
                      adminList.push(item);
                    }
                  });
                  if (managerList.length == 0) {
                    managerList.push({ ratio: 100 });
                  }
                  if (adminList.length == 0) {
                    adminList.push({ ratio: 100 });
                  }
                  this.form.managerList = managerList;
                  this.form.adminList = adminList;
                  console.log(this.form);
                  this.setStaff();
                } else {
                  this.$alert(res.message, "加载门店高管", {
                    confirmButtonText: "确定",
                    confirmButtonClass: "confirmbtnFalses",
                    type: "warning",
                    center: true,
                    callback: (action) => {},
                  });
                }
              }
            );
          }
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.flex{
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/eashier/refundCourse/components/detail.vue